export default __webpack_public_path__ + "../staticImages/instagram-icon.jpg";